import React, { useEffect, useRef, useState } from 'react';
import Button from '../../../../ui-core/Button/Button';
import Counter from '../OtpModal/Counter';
import { getItem, removeItem, setItem } from '../../../../utils/cache';
import { useDispatch, useSelector } from 'react-redux';
import { doVerifyOtpAndMergeAccounts } from '../../../../store/action/auth';
import { LOCAL_STORAGE_CONSTANT, MODAL_TYPE } from '../../../../constants/app';
import { APP_ROUTES } from '../../../../route';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { processOfflineCart } from '../../../../utils/offlineCart';

const EmailOtpModal = ({ handleModalState, handleClose = () => {} }) => {
  const history = useHistory();
  const mergeEmail = JSON.parse(getItem('mergeEmailDetail'))?.email;
  const socialLoginData = JSON.parse(localStorage.getItem('SocialLoginData'));
  const inputRef = useRef([]);
  const { user } = useSelector(state => state.auth);
  const initialState = new Array(4).fill('');
  const [otp, setOtp] = useState(initialState);
  const [postData, setPostData] = useState({
    type: 'email',
    email: mergeEmail,
    code: otp.join(''),
  });
  const { isLoading } = useSelector(state => state.common);
  const { isLoading: loading } = useSelector(state => state.product);
  const userData = user;
  const numLen =
    user?.attributes?.mobile.toString().length ||
    socialLoginData?.mobile?.toString().length;
  let maskInput = 'X';
  for (let i = 0; i < numLen - 5; i++) {
    maskInput = maskInput + 'X';
  }

  const dispatch = useDispatch();
  const [otpError, setOtpError] = useState(false);
  const [otpDisabled, setOtpDisabled] = useState(false);

  useEffect(() => {
    let isMounted = true;
    setPostData({
      ...postData,
      mobile: userData?.attributes?.mobile || socialLoginData?.mobile,
      country_code:
        userData?.attributes?.country_code || socialLoginData?.country_code,
    });
    try {
      if (isMounted) {
        setOtp(initialState);
        if (inputRef.current[0] && inputRef.current[0]?.focus)
          inputRef.current[0].focus();
      }
    } catch (e) {
      if (isMounted) {
        throw e;
      }
    }
    return (isMounted = false);
  }, [userData]);

  const handleOtpChange = (element, index) => {
    if (element && isNaN(element.value)) return false;
    const otpData = [
      ...otp.map((d, idx) => (idx === index ? element.value : d)),
    ];

    if (element && otpData[index] !== '') {
      element.classList.add('filled');
    } else {
      element?.classList?.remove('filled');
    }
    setOtp(otpData);
    if (element.value) {
      setTimeout(() => {
        inputRef?.current[index + 1]?.focus();
      });
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.keyCode === 8) {
      setTimeout(() => {
        inputRef?.current[index - 1]?.focus();
        inputRef?.current[index - 1]?.select();
      }, 5);
    } else if (event.keyCode === 13 && otp.every(i => Boolean(i))) {
      handleOtpSubmit();
    }
  };

  const handleOtpSubmit = () => {
    // Remove error class
    otp?.forEach((input, index) => {
      inputRef?.current[index]?.classList?.remove('error');
    });
    setOtpError(false); // Reset error
    const payload = {
      type: 'email',
      email: mergeEmail,
      code: otp.join(''),
    };
    dispatch(
      doVerifyOtpAndMergeAccounts({
        data: { ...payload },
        callback: () => {
          const updatedUser = {
            ...user,
            attributes: {
              ...user.attributes,
              email: mergeEmail,
            },
          };
          setItem(LOCAL_STORAGE_CONSTANT.USER, JSON.stringify(updatedUser));
          // handleModalState(MODAL_TYPE.ASSESSMENT);
          removeItem('AccountMerge');
          removeItem('mergeEmailDetail');
          removeItem('isPhoneLogin');
          const isRedirectCourse = getItem('redirectToCourse');
          if (isRedirectCourse) {
            handleClose();
          } else {
            const isOfflineCheckout = JSON.parse(getItem('isOfflineCheckout'));
            if (isOfflineCheckout) {
              processOfflineCart({ dispatch });
            } else {
              handleModalState(null);
              history.push(APP_ROUTES.HOME);
            }
          }
        },
        errorCallback: () => {
          handleModalState(MODAL_TYPE.EMAIL_OTP);
          otp?.forEach((input, index) => {
            inputRef?.current[index]?.classList?.add('error');
          });
          setOtpError(true);
        },
      }),
    );
  };

  return (
    <>
      <div className="form-h">
        <h1 className="otp-h2 mb-3">Enter code</h1>
        <p className="sign-in-h3 mt-4 pb-2">
          Just one last step to verify your email address
        </p>
        <div
          className="w-100 mt-3 mb-3"
          style={{ border: '0.5px solid #E3E3E6' }}
        ></div>
        <h3 className="otp-h3 text-center mb-0">
          Enter the verification code sent
        </h3>
        <h3 className="otp-h3 text-center">
          on your Email <span>{mergeEmail || ''}</span>
        </h3>
        <div className="otp-field-wrap d-flex align-items-center justify-content-evenly">
          {otp.map((data, index) => {
            return (
              <input
                inputMode="numeric"
                pattern="[0-9]*"
                className="otp-field"
                type="text"
                name="otp"
                placeholder="-"
                maxLength="1"
                key={index}
                value={data}
                onChange={evt => handleOtpChange(evt.target, index)}
                onFocus={evt => evt.target.select()}
                disabled={otpDisabled}
                onKeyDown={evt => handleKeyDown(evt, index)}
                ref={el => (inputRef.current[index] = el)}
              />
            );
          })}
        </div>
        <div className="text-center mt-0">
          {otpError && (
            <p style={{ color: '#EE4343' }}>You entered the wrong code</p>
          )}
        </div>
        <Counter
          // page={props.page}
          postData={postData}
          otp={otp}
          setOtp={setOtp}
          setOtpDisabled={setOtpDisabled}
          // fromPage={'reset-otp'}
          handleModalState={handleModalState}
          inputRef={inputRef}
          setOtpError={setOtpError}
        />

        <Button
          class={`verify-button ${isLoading && ''}`}
          text="VERIFY"
          isDisabled={isLoading || !otp.every(i => Boolean(i)) || loading}
          isLoading={isLoading || loading}
          onClick={() => handleOtpSubmit()}
        />
      </div>
    </>
  );
};

EmailOtpModal.propTypes = {
  handleModalState: PropTypes.func,
  handleClose: PropTypes.func,
};

export default EmailOtpModal;
